module.exports = __webpack_public_path__ + "img/ID_BG_Icon.77f0ad16.svg";